import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface Product {
  productId: string;
  name: string;
  description: string;
  category: 'pedal' | 'sample' | 'preset';
  price: number;
  imageUrl?: string;
  developerId: string;
  status: 'active' | 'inactive';
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export function useProducts(category?: Product['category']) {
  return useQuery({
    queryKey: ['products', category],
    queryFn: async () => {
      const queryParams = category ? { category } : undefined;
      const response = await apiClient.get<ApiResponse<Product[]>>('/marketplace/products', {
        queryParams,
      });
      if (!response.success) {
        throw new Error(response.message || 'Failed to load products');
      }
      return response.data;
    },
  });
}

export function useProduct(productId: string) {
  return useQuery({
    queryKey: ['products', productId],
    queryFn: async () => {
      const response = await apiClient.get<ApiResponse<Product>>(`/marketplace/products/${productId}`);
      if (!response.success) {
        throw new Error(response.message || 'Failed to load product');
      }
      return response.data;
    },
    enabled: !!productId,
  });
}
